import { render, staticRenderFns } from "./DatepickerDialog.vue?vue&type=template&id=04f408be&"
import script from "./DatepickerDialog.vue?vue&type=script&lang=js&"
export * from "./DatepickerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports